import React from 'react';
import { Checkbox, TableCell, TableRow as MaterialTableRow } from '@mui/material';


interface Props<T extends {}> {
  rowKey: React.Key;
  row: T;
  enableCheck: boolean;
  columns?: string[];
  valueMap?: {[key: string]: (value: any) => any}
  onRowClick?: (event: React.MouseEvent<unknown>, row: T, key: React.Key) => void;
  onCheckboxClick?: (isChecked: boolean, row: T, key: React.Key) => void;
  isChecked?: boolean;
}

export const TableRow = <T extends {},>(props: Props<T>) => {
  const { rowKey, row, valueMap, columns, enableCheck, isChecked = false, onRowClick, onCheckboxClick } = props;
  const labelId = `enhanced-table-checkbox-${rowKey}`;
  let data = row;

  if (columns != null) {
    data = columns.map((c) => {
      const val = getFromObj(row, c)
      // Return object value mapped if the column is in valueMap else
      // return the raw value
      return { [c]: valueMap ? c in valueMap ? valueMap[c](val) : val : val } as T
    })
    .reduce((a, b) => (
      { ...a, ...b }
    ));
  }

  const onCheckClick = (/*event: React.MouseEvent<HTMLTableDataCellElement>*/) => {
    if (onCheckboxClick !== undefined) {
      onCheckboxClick(isChecked, row, rowKey);
    }
  };

  return (
    <MaterialTableRow
      hover
      role={enableCheck ? 'checkbox' : undefined}
      aria-checked={isChecked}
      tabIndex={-1}
      key={rowKey} // Check if id exist here.
      selected={isChecked}
    >
      {enableCheck && (
        <TableCell
          padding="checkbox"
          onClick={onCheckboxClick ? onCheckClick : (event) => onRowClick && onRowClick(event, row, rowKey)}
        >
          <Checkbox checked={isChecked} inputProps={{ 'aria-labelledby': labelId }} />
        </TableCell>
      )}
      {Object.entries(data).map((entry, i) => (
        <TableCell key={i} onClick={(event) => onRowClick && onRowClick(event, row, rowKey)}>
          {entry[1] != null ? entry[1].toString() : null}
        </TableCell>
      ))}
    </MaterialTableRow>
  );
};

function getFromObj<T>(obj: T, key: string): any {
  const keys = key.toString().split('.');
  let finalObj = obj as any;
  keys.forEach((k) => {
    finalObj = finalObj !== '' && finalObj !== null && k in finalObj ? finalObj[k as keyof typeof finalObj] : '';
  });
  return finalObj;
}
